import { HStack } from '@chakra-ui/react'
import ImageBox from 'components/common/ImageBox'
import IfopNavigation from 'components/markdown/components/IfopNavigation'
import { FC } from 'react'

const IfopCoronaNavigation: FC = () => {
  return (
    <>
      <IfopNavigation
        title="Étude IFOP - Charles"
        links={[
          {
            to: '/ifop-les-francais-face-au-coronavirus/',
            content: (
              <HStack>
                <ImageBox alt="graph" src="/icons/open-iconic/svg/graph.svg" height="3rem" width="3rem" />
                <span>Ver o relatório</span>
              </HStack>
            )
          },
          {
            to: '/rapport-complet-ifop-les-francais-face-au-coronavirus/',
            content: (
              <HStack>
                <ImageBox alt="book" src="/icons/open-iconic/svg/book.svg" height="3rem" width="3rem" />
                <span>Voir l&apos;enquête complète</span>
              </HStack>
            )
          },
          {
            to: '/infographie-etude-ifop-francais-coronavirus/',
            content: (
              <HStack>
                <ImageBox alt="paperclip" src="/icons/open-iconic/svg/paperclip.svg" height="3rem" width="3rem" />
                <span>Infographie</span>
              </HStack>
            )
          }
        ]}
      />
    </>
  )
}

export default IfopCoronaNavigation
